import * as React from "react"
const SvgComponent = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    xmlSpace="preserve"
    style={{
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd",
    }}
    viewBox="0 0 64834 52826"
    {...props}
  >
    <path
      d="m400 316 32016 35282L64434 316 32416 51932z"
      style={{
        fill: "#2b2a29",
        stroke: "#2b2a29",
        strokeWidth: 941.667,
      }}
      className="stroke1 fill"
    />
  </svg>
)
export default SvgComponent
